var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnTableCellSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18L14.3301 12.75H5.66987L10 18Z",
    fill: "#172664"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 3,
    x2: 10,
    y2: 17,
    stroke: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTableCellSortDown);
export default __webpack_public_path__ + "static/media/btn_table_cell_sort_down.ca0a1d5af14ae15059da7ffea63e65d1.svg";
export { ForwardRef as ReactComponent };